export default () => {
  return {
    EWS_CARDS_STATUS: {
      financials: true,
      ratings: true,
      countryRisk: true,
      macroIndicators: true,
      news: true,
      marketIndicators: true,
    },
    EWS_CARDS_POSITION: [
      'countryRisk',
      'marketIndicators',
      'ratings',
      'financials',
      'macroIndicators',
      'newsSentiment',
      'latestNews',
    ],
    preferences: {
      homepage: '',
      persona: 'Generic',
      scale: 'millions',
      precision: '0.00',
      landingPage: 'home',
      magnitude: 6,
      decimalPrecision: 1,
      timezone: 'GMT',
    },
    researchUserSettings: {
      language: 'All Languages',
      displayCount: 25,
      showSummary: false,
    },
    entity: { displayOrder: 'Latest to Oldest', hideEmptyRows: false },
    portfolio: { preferences: {}, recent: [] },
    portfolios: { recent: [] },
    tours: {
      esg: 'false',
      scorecard: 'false',
      srm: 'false',
      biri: 'true',
      screener: 'true',
    },
    sectorGeoFilter: {
      name: '',
      filterCriteria: [],
      type: '',
      idsCollection: [],
    },
    homePage: {},
    BMINotification: 'true',
    researchSortSettings: { searchSort: 'Date (Latest First)' },
    ewsSettings: {
      marketIndicatorsTimeFrame: 'Daily',
      latestNewsTimeFrame: 'Weekly',
      newsSentimentTimeFrame: 'Weekly',
      ratingsTimeFrame: 'Weekly',
      financialTimeFrame: 'Quarterly',
      countryRiskTimeFrame: 'Yearly',
    },
    researchBookmarks: {},
    researchs: { recent: [] },
    entities: { recent: [] },
    sector: {},
    countryRisk: {},
  };
};
